import React from 'react'
import './style.css'

import ReactTooltip from 'react-tooltip'
import MCEadCourse from "../Course"
import {getClassTypeNameByCode} from "../../../../helpers/product"


const CourseWrapper = (props) => {
    const {
        active,
        code,
        title,
        image,
        progress,
        startDate,
        classType,
        endDate
    } = props


    return (
        <React.Fragment>
            <div
                key={code}
                onClick={(evt) => {
                    evt.preventDefault()

                    if (!active)
                        return

                    props.onClick(code)
                }}

                data-tip={
                    active ?
                        null : 'Seu acesso ainda não foi liberado.<br/>Efetue o pagamento de sua inscrição ou entre em contato conosco.'
                }
                data-for={code}
                style={{
                    cursor: active ? 'pointer' : 'not-allowed',
                }}

            >

                <MCEadCourse title={title}
                             imgSrc={image}
                             progress={progress}
                             startDate={startDate}
                             endDate={endDate}
                             active={active}
                             type={getClassTypeNameByCode(classType)}
                />


            </div>

            <ReactTooltip id={code + ''} html/>
        </React.Fragment>
    )
}

CourseWrapper.propTypes = {}
CourseWrapper.defaultProps = {}

export default CourseWrapper


// WEBPACK FOOTER //
// ./src/components/_ead/_courseList/CourseWrapper/index.js